import plainQuranText from './quran-uthmani'
import quranData from './quran-data'
import VersCard from '../components/VerseCard/VerseCard'
import React from 'react'

let quranText = plainQuranText.split('\n').map(aya => [aya])
// let quranText = plainQuranText.split('\n').map(aya => aya.split(/(ۚ|ۗ)/g))

const Quran = {}

Quran.quranText = quranText

/**
 * دریافت شماره‌ی سوره و آیه، بر اساس شماره‌ی آیه از شروع کل قرآن
 * @param {number} globalAya شماره‌ي آیه از ابتدای قرآن
 * @returns {{suraNumber, ayaNumber, suraName}}
 */
Quran.getSuraAndAya = function(globalAya) {
    for (let i=1; i < quranData.Sura.length; i++) {
        if (quranData.Sura[i][0] > globalAya) {
            return {
                suraNumber: i-1,
                ayaNumber: globalAya - quranData.Sura[i-1][0] + 1,
                suraName: Quran.suras[i-1].pname
            }
        }
    }
    return null;
}

/**
 * دریافت شماره سراسری آیه بر اساس شماره‌ی سوره و آیه
 * @param {number} sura شماره‌ی سوره
 * @param {number} aya شماره‌ی آیه در سوره
 * @returns {number}
 */
Quran.getGlobalAyaNumber = function(sura, aya) {
    try {
        return Quran.suras[sura].start + aya - 1
    } catch(err) {
        console.error('global aya not found')
        return -1
    }
}

/**
 * بررسی اینکه آیه‌ی مورد نظر اوّلین آیه‌ی یک سوره است یا خیر
 * @param {number} globalAya شماره‌ی سراسری آیه
 * @returns {boolean}
 */
Quran.isFirstAyaOfSura = function (globalAya) {
    return Quran.suras.some(sura => sura.start === globalAya)
}

/**
 * @type {Array<{number, start, ayas, order, rukus, name, pname, tname, ename, type}>}
 */
Quran.suras = quranData.Sura.map((sura, number) => ({
    number,
    start: sura[0],
    ayas : sura[1],
    order: sura[2],
    rukus: sura[3],
    name : sura[4],
    tname: sura[5],
    ename: sura[6],
    type : sura[7],
    pname: sura[4] && sura[4]
                .replace(/^ال/, '')
                .replace(/^(أ|إ)/, 'ا')
                .replace(/ة$/, 'ه')
                .replace(/إ$/, 'أ')
}))

function SuraTitle({title}) {
    return (
      <div className="review__sura-title">
        {title}
      </div>
    )
  }
Quran.ayaTags = quranText.map((aya, i) => {
    const card = <VersCard key={i} globalAya={i} isDefaultRotated={false} />
    if (i === 6230) return null
    if (Quran.isFirstAyaOfSura(i)) {
        const sura = Quran.getSuraAndAya(i)
        return (<React.Fragment key={i}>
            <SuraTitle key={`sura-${i}`} title={`سوره‌ی ${sura.suraName}`} />
            {i !== 1235 && i !== 0 && <div key={`basmaleh-${i}`} class="basmaleh"></div>}
            {card}
        </React.Fragment>)
    }
    return card
})

export default Quran


// WEBPACK FOOTER //
// ./src/quran/Quran.js